// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d7fa5542","703":"bedd6078"}[chunkId] + ".chunk.js";
};